import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomFields = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 12.133,
			height: 6.8,
			x: 1.934,
			y: 4.6,
			stroke: "currentColor",
			strokeWidth: 1.2,
			rx: 2.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.667,
			height: .96,
			x: 4,
			y: 7.333,
			fill: "currentColor",
			rx: .48
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.2,
			d: "m10 7.333.872 1.047c.067.08.19.08.256 0L12 7.333"
		})
	]
});
export default SvgCustomFields;
